import { render, staticRenderFns } from "./Encuestas.vue?vue&type=template&id=7939fab2&scoped=true&"
import script from "./Encuestas.vue?vue&type=script&lang=js&"
export * from "./Encuestas.vue?vue&type=script&lang=js&"
import style0 from "./Encuestas.vue?vue&type=style&index=0&id=7939fab2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7939fab2",
  null
  
)

export default component.exports